import { createReducer, on } from "@ngrx/store";
import { GenericStoreApiData } from "src/components/shared-components/interfaces/generic-store-api-data";
import {
  translationLoadErrorAction,
  translationLoadInitStartAction,
  translationLoadSuccessAction,
  translationPopulateWithOldDataAction,
  translationUnsetKeyStorage,
} from "../actions/translation.actions";

/**
 * Initial state of translation store
 */
const initialState: GenericStoreApiData = {
  loaded: false,
  errorGeneric: false,
  errorNotYetImplemented: false,
  isOldDataInUse: false,
  data: null,
};

/**
 * Reducer for translation
 */
export const TranslationReducer = createReducer(
  initialState,
  on(
    translationUnsetKeyStorage,
    (translationObject: GenericStoreApiData, action) => {
      return initialState;
    }
  ),
  /*
    on(
      translationLoadInitStartAction,
      (translationObject: GenericStoreApiData, action) => {
        return { ...translationObject, loaded: false };
      }
    ),
  */
  on(
    translationLoadSuccessAction,
    (translationObject: GenericStoreApiData, action) => {
      return {
        loaded: true,
        errorGeneric: false,
        errorNotYetImplemented: false,
        isOldDataInUse: false,
        data: action.translationObject,
      };
    }
  ),
  on(
    translationPopulateWithOldDataAction,
    (translationObject: GenericStoreApiData, action) => {
      return {
        loaded: true,
        errorGeneric: false,
        errorNotYetImplemented: false,
        isOldDataInUse: true,
        data: action.oldTranslationObject,
      };
    }
  ),
  on(
    translationLoadErrorAction,
    (translationObject: GenericStoreApiData, action) => {
      return {
        loaded: true,
        errorGeneric: true,
        errorNotYetImplemented: false,
        isOldDataInUse: false,
        data: null,
      };
    }
  )
);
